import { useEffect } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

import { ModelProvider } from '../../components/model-context/ModelProvider.tsx';
import LegacyCadProjectWizard from '../../components/new-project-cad-legacy/CadProjectWizard';
import ProjectWizard from '../../components/new-project/ProjectWizard';
import { useAppDispatch } from '../../hooks';
import { useDrawingsEnabled } from '../../hooks/useDrawingsEnabled';
import { projectsReducer } from '../../store/reducers/projects.reducer';
import { userReducer } from '../../store/reducers/user.reducer';

export const NewProjectPage = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const isPolygonFlow = searchParams.get('flow') === 'polygon';
  // With the "drawings" feature a plan is drawn in the Drawings tab (the editor works on a saved
  // drawing); the old polygon flow stays for everyone else.
  const drawingsEnabled = useDrawingsEnabled();

  useEffect(() => {
    dispatch(userReducer.actions.loadNorms());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      if (window.location.pathname !== '/new-project') {
        dispatch(projectsReducer.actions.resetNewProject());
      }
    };
  }, [location, dispatch]);

  if (isPolygonFlow && drawingsEnabled) return <Navigate to="/drawings" replace />;
  return <ModelProvider>{isPolygonFlow ? <LegacyCadProjectWizard /> : <ProjectWizard />}</ModelProvider>;
};
